export default [
	{
		"value": 1,
		"label": "集装箱船",
		"children": [{
			"value": 2,
			"label": "部分集装箱船"
		}, {
			"value": 3,
			"label": "全集装箱船"
		}, {
			"value": 4,
			"label": "江海联运集装箱船"
		}, {
			"value": 5,
			"label": "超大型集装箱船"
		}]
	}, {
		"value": 6,
		"label": "油船",
		"children": [{
			"value": 7,
			"label": "原油运输船"
		}, {
			"value": 8,
			"label": "成品油运输船"
		}, {
			"value": 9,
			"label": "巴拿马型油船"
		}, {
			"value": 10,
			"label": "阿芙拉型油船"
		}, {
			"value": 11,
			"label": "苏伊士型油船"
		}, {
			"value": 12,
			"label": "超大型油轮VLCC"
		}, {
			"value": 13,
			"label": "巨型油轮ULCC"
		}]
	}, {
		"value": 14,
		"label": "散货船",
		"children": [{
			"value": 15,
			"label": "大湖型散货船"
		}, {
			"value": 16,
			"label": "灵便型散货船"
		}, {
			"value": 17,
			"label": "巴拿马型散货船"
		}, {
			"value": 18,
			"label": "好望角型散货船"
		}, {
			"value": 19,
			"label": "超大型散货船"
		}, {
			"value": 20,
			"label": "超大型矿砂船VLOC"
		}]
	}, {
		"value": 21,
		"label": "液货船",
		"children": [{
			"value": 22,
			"label": "化学品船"
		}, {
			"value": 23,
			"label": "沥青运输船"
		}, {
			"value": 24,
			"label": "酒精运输船"
		}, {
			"value": 25,
			"label": "LNG船"
		}, {
			"value": 26,
			"label": "LPG船"
		}]
	}, {
		"value": 27,
		"label": "干货船",
		"children": [{
			"value": 28,
			"label": "纸浆船"
		}, {
			"value": 29,
			"label": "运木船"
		}, {
			"value": 30,
			"label": "运石船"
		}, {
			"value": 31,
			"label": "滚装货船"
		}, {
			"value": 32,
			"label": "牲畜运输船"
		}, {
			"value": 33,
			"label": "重大件运输船"
		}]
	}, {
		"value": 34,
		"label": "客船",
		"children": [{
			"value": 35,
			"label": "客船"
		}, {
			"value": 36,
			"label": "渡船"
		}, {
			"value": 37,
			"label": "游艇"
		}, {
			"value": 38,
			"label": "客滚船"
		}, {
			"value": 39,
			"label": "内河游轮"
		}, {
			"value": 40,
			"label": "豪华邮轮"
		}]
	}, {
		"value": 41,
		"label": "钻井平台",
		"children": [{
			"value": 42,
			"label": "自生式钻井平台"
		}, {
			"value": 43,
			"label": "半潜式钻井平台"
		}, {
			"value": 44,
			"label": "坐底式海洋平台"
		}, {
			"value": 45,
			"label": "导管架式平台"
		}, {
			"value": 46,
			"label": "张力腿式平台"
		}, {
			"value": 47,
			"label": "钻井船"
		}, {
			"value": 48,
			"label": "钻井驳船"
		}]
	}, {
		"value": 49,
		"label": "海工船",
		"children": [{
			"value": 50,
			"label": "起重船"
		}, {
			"value": 51,
			"label": "铺管船"
		}, {
			"value": 52,
			"label": "打桩船"
		}, {
			"value": 53,
			"label": "半潜船"
		}, {
			"value": 54,
			"label": "三维物探船"
		}, {
			"value": 55,
			"label": "风电安装船"
		}, {
			"value": 56,
			"label": "平台供应船PSV"
		}, {
			"value": 57,
			"label": "潜水支持船ROV"
		}, {
			"value": 58,
			"label": "三用工作船AHTS"
		}, {
			"value": 59,
			"label": "FPSO"
		}, {
			"value": 60,
			"label": "FLNG"
		}]
	}, {
		"value": 61,
		"label": "公务船",
		"children": [{
			"value": 62,
			"label": "海警船"
		}, {
			"value": 63,
			"label": "海监船"
		}, {
			"value": 64,
			"label": "海巡船"
		}, {
			"value": 65,
			"label": "渔政船"
		}, {
			"value": 66,
			"label": "执法船"
		}, {
			"value": 67,
			"label": "消防船"
		}]
	}, {
		"value": 68,
		"label": "渔船",
		"children": [{
			"value": 69,
			"label": "拖网船"
		}, {
			"value": 70,
			"label": "围网船"
		}, {
			"value": 71,
			"label": "捕鲸船"
		}, {
			"value": 72,
			"label": "运鱼船"
		}, {
			"value": 73,
			"label": "渔业支持船"
		}, {
			"value": 74,
			"label": "活鱼运输船"
		}, {
			"value": 75,
			"label": "渔业加工船"
		}]
	}, {
		"value": 76,
		"label": "军舰",
		"children": [{
			"value": 77,
			"label": "航母"
		}, {
			"value": 78,
			"label": "驱逐舰"
		}, {
			"value": 79,
			"label": "护卫舰"
		}, {
			"value": 80,
			"label": "巡洋舰"
		}, {
			"value": 81,
			"label": "登陆舰"
		}, {
			"value": 82,
			"label": "布雷艇"
		}, {
			"value": 83,
			"label": "导弹艇"
		}, {
			"value": 84,
			"label": "鱼雷艇"
		}, {
			"value": 85,
			"label": "潜艇"
		}]
	}, {
		"value": 86,
		"label": "特种船",
		"children": [{
			"value": 87,
			"label": "科考船"
		}, {
			"value": 88,
			"label": "破冰船"
		}, {
			"value": 89,
			"label": "医疗船"
		}, {
			"value": 90,
			"label": "打捞船"
		}, {
			"value": 91,
			"label": "地效翼船"
		}, {
			"value": 92,
			"label": "引航船"
		}, {
			"value": 93,
			"label": "海洋牧场"
		}, {
			"value": 94,
			"label": "汽车运输船"
		}, {
			"value": 95,
			"label": "高校实习船"
		}]
	}, {
		"value": 104,
		"label": "挖泥船",
		"children": [{
			"value": 105,
			"label": "耙吸式挖泥船"
		}, {
			"value": 106,
			"label": "绞吸式挖泥船"
		}, {
			"value": 107,
			"label": "抓斗式挖泥船"
		}, {
			"value": 108,
			"label": "铲斗式挖泥船"
		}, {
			"value": 109,
			"label": "链斗式挖泥船"
		}]
	}
]
